// extracted by mini-css-extract-plugin
export default {"section__word":"Word_section__word__rQBBW","sound":"Word_sound__wmGxC","word":"Word_word__05iBY","phonetic":"Word_phonetic__aQIXE","error":"Word_error__L6Os7"};